import React from 'react';

import '../../css/chat-empty-state.css';

const ChatEmptyState = () => (
  <div className="chat-empty-state">
    <div className="chat-empty-state__art" aria-hidden="true">
      <span className="chat-empty-state__grid"></span>
      <span className="chat-empty-state__orbit chat-empty-state__orbit--one"></span>
      <span className="chat-empty-state__orbit chat-empty-state__orbit--two"></span>
      <span className="chat-empty-state__channel chat-empty-state__channel--facebook">f</span>
      <span className="chat-empty-state__channel chat-empty-state__channel--zalo">Z</span>
      <span className="chat-empty-state__channel chat-empty-state__channel--web">W</span>
      <span className="chat-empty-state__agent"><i className="far fa-comment-dots"></i><b>AI</b></span>
      <span className="chat-empty-state__message chat-empty-state__message--one"></span>
      <span className="chat-empty-state__message chat-empty-state__message--two"></span>
      <span className="chat-empty-state__message chat-empty-state__message--three"></span>
    </div>
    <div className="chat-empty-state__copy">
      <p>Tổng đài đa kênh</p>
      <h2>Chọn một hội thoại để bắt đầu</h2>
      <span>Tin nhắn từ Facebook, Zalo và các kênh khác sẽ được tập trung tại đây.</span>
    </div>
  </div>
);

export default ChatEmptyState;
